import React from "react";

interface props {
  d: string;
  size: number;
}

interface str {
  [prop: string]: props;
}

const icons: str = {
  cross: {
    d:
      "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41z",
    size: 24,
  },
  calendar: {
    d:
      "M6.984375 1.9863281 A 1.0001 1.0001 0 0 0 6 3L6 4L5 4C3.9069372 4 3 4.9069372 3 6L3 20C3 21.093063 3.9069372 22 5 22L19 22C20.093063 22 21 21.093063 21 20L21 6C21 4.9069372 20.093063 4 19 4L18 4L18 3 A 1.0001 1.0001 0 0 0 16.984375 1.9863281 A 1.0001 1.0001 0 0 0 16 3L16 4L8 4L8 3 A 1.0001 1.0001 0 0 0 6.984375 1.9863281 z M 5 9L19 9L19 20L5 20L5 9 z M 13 13C12.448 13 12 13.448 12 14L12 17C12 17.552 12.448 18 13 18L16 18C16.552 18 17 17.552 17 17L17 14C17 13.448 16.552 13 16 13L13 13 z",
    size: 24,
  },
  avatar: {
    d:
      "M30.933594 32.527344C30.785156 30.914063 30.84375 29.789063 30.84375 28.316406C31.574219 27.933594 32.882813 25.492188 33.101563 23.429688C33.675781 23.382813 34.582031 22.824219 34.847656 20.613281C34.988281 19.425781 34.421875 18.757813 34.074219 18.546875C35.007813 15.738281 36.949219 7.046875 30.488281 6.148438C29.820313 4.980469 28.117188 4.390625 25.90625 4.390625C17.050781 4.554688 15.984375 11.078125 17.925781 18.546875C17.578125 18.757813 17.011719 19.425781 17.152344 20.613281C17.421875 22.824219 18.324219 23.382813 18.898438 23.429688C19.117188 25.492188 20.476563 27.933594 21.210938 28.316406C21.210938 29.789063 21.265625 30.914063 21.117188 32.527344C19.367188 37.238281 7.546875 35.914063 7 45L45 45C44.453125 35.914063 32.683594 37.238281 30.933594 32.527344Z",
    size: 48,
  },
  setting: {
    d:
      "M10.490234 2C10.011234 2 9.6017656 2.3385938 9.5097656 2.8085938L9.1757812 4.5234375C8.3550224 4.8338012 7.5961042 5.2674041 6.9296875 5.8144531L5.2851562 5.2480469C4.8321563 5.0920469 4.33375 5.2793594 4.09375 5.6933594L2.5859375 8.3066406C2.3469375 8.7216406 2.4339219 9.2485 2.7949219 9.5625L4.1132812 10.708984C4.0447181 11.130337 4 11.559284 4 12C4 12.440716 4.0447181 12.869663 4.1132812 13.291016L2.7949219 14.4375C2.4339219 14.7515 2.3469375 15.278359 2.5859375 15.693359L4.09375 18.306641C4.33275 18.721641 4.8321562 18.908906 5.2851562 18.753906L6.9296875 18.1875C7.5958842 18.734206 8.3553934 19.166339 9.1757812 19.476562L9.5097656 21.191406C9.6017656 21.661406 10.011234 22 10.490234 22L13.509766 22C13.988766 22 14.398234 21.661406 14.490234 21.191406L14.824219 19.476562C15.644978 19.166199 16.403896 18.732596 17.070312 18.185547L18.714844 18.751953C19.167844 18.907953 19.66625 18.721641 19.90625 18.306641L21.414062 15.691406C21.653063 15.276406 21.566078 14.7515 21.205078 14.4375L19.886719 13.291016C19.955282 12.869663 20 12.440716 20 12C20 11.559284 19.955282 11.130337 19.886719 10.708984L21.205078 9.5625C21.566078 9.2485 21.653063 8.7216406 21.414062 8.3066406L19.90625 5.6933594C19.66725 5.2783594 19.167844 5.0910937 18.714844 5.2460938L17.070312 5.8125C16.404116 5.2657937 15.644607 4.8336609 14.824219 4.5234375L14.490234 2.8085938C14.398234 2.3385937 13.988766 2 13.509766 2L10.490234 2 z M 12 8C14.209 8 16 9.791 16 12C16 14.209 14.209 16 12 16C9.791 16 8 14.209 8 12C8 9.791 9.791 8 12 8 z",
    size: 24,
  },
  error: {
    d:
      "M12 4C9.6655084 4 7.7006133 5.2494956 6.4296875 7.0136719C2.8854572 7.05389 0 9.9465993 0 13.5C0 17.078268 2.9217323 20 6.5 20L18.5 20C21.525577 20 24 17.525577 24 14.5C24 11.509638 21.577034 9.0762027 18.599609 9.0195312C17.729938 6.1415745 15.152096 4 12 4 z M 12 6C14.504527 6 16.55398 7.825491 16.931641 10.214844L17.083984 11.175781L18.048828 11.050781C18.272182 11.021699 18.414903 11 18.5 11C20.444423 11 22 12.555577 22 14.5C22 16.444423 20.444423 18 18.5 18L6.5 18C4.0022677 18 2 15.997732 2 13.5C2 11.002268 4.0022677 9 6.5 9C6.534993 9 6.6164592 9.0069899 6.75 9.0136719L7.3613281 9.0449219L7.6660156 8.5136719C8.5301088 7.0123517 10.137881 6 12 6 z M 11 8L11 13L13 13L13 8L11 8 z M 11 15L11 17L13 17L13 15L11 15 z",
    size: 24,
  },
  trash: {
    size: 24,
    d:
      "M10 2L9 3L5 3C4.448 3 4 3.448 4 4C4 4.552 4.448 5 5 5L7 5L17 5L19 5C19.552 5 20 4.552 20 4C20 3.448 19.552 3 19 3L15 3L14 2L10 2 z M 5 7L5 20C5 21.105 5.895 22 7 22L17 22C18.105 22 19 21.105 19 20L19 7L5 7 z",
  },
};

export default function IconProvider(iconName: string) {
  if (icons[iconName]) {
    const icon = icons[iconName];
    return (
      <svg viewBox={`0 0 ${icon.size} ${icon.size}`}>
        <path d={icon.d}></path>
      </svg>
    );
  } else {
    return new Error("Invalid iconName!!!");
  }
}
